var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(-337 -737)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6720",
    "data-name": "Rectangle 6720",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(337 737)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-4920320",
    transform: "translate(332.339 732.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32560",
    "data-name": "Path 32560",
    d: "M27.122,24.884a1.24,1.24,0,0,1,0,1.751l-.484.483a1.24,1.24,0,0,1-1.751,0L19.572,21.8l-5.315,5.315a1.239,1.239,0,0,1-1.751,0l-.484-.483a1.24,1.24,0,0,1,0-1.751l5.315-5.315-5.315-5.315a1.24,1.24,0,0,1,0-1.751l.483-.483a1.238,1.238,0,0,1,1.751,0l5.315,5.315,5.315-5.315a1.238,1.238,0,0,1,1.751,0l.483.484a1.24,1.24,0,0,1,0,1.751l-5.315,5.315Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.3cceab52e76ad0d14537c057ee78016b.svg";
export { ForwardRef as ReactComponent };